import { render, staticRenderFns } from "./game-betconstruct.vue?vue&type=template&id=6140085b"
import script from "./game-betconstruct.vue?vue&type=script&lang=js"
export * from "./game-betconstruct.vue?vue&type=script&lang=js"
import style0 from "./game-betconstruct.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-betconstruct.vue
// module id = fiAN
// module chunks = 0